var app = [];

(function() {

	function initSelect2Fields(context) {
		if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.select2 === 'undefined') {
			return;
		}

		var $context = context ? window.jQuery(context) : window.jQuery(document);
		var $fields = $context.find('.js-select2');

		if ($context.is('.js-select2')) {
			$fields = $fields.add($context);
		}

		$fields.each(function() {
			var $field = window.jQuery(this);
			if ($field.hasClass('select2-hidden-accessible')) {
				return;
			}

			var dropdownParentSelector = $field.data('select2-dropdown-parent');
			var dropdownParent = dropdownParentSelector ? window.jQuery(dropdownParentSelector) : null;

			$field.select2({
				placeholder: $field.data('placeholder') || '',
				minimumResultsForSearch: 0,
				width: '100%',
				dropdownParent: dropdownParent && dropdownParent.length ? dropdownParent : undefined,
				allowClear: false
			});
		});
	}

	function observeSelect2Fields() {
		if (typeof MutationObserver === 'undefined' || typeof document.body === 'undefined') {
			return;
		}

		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.type === 'childList') {
					Array.prototype.forEach.call(mutation.addedNodes, function(node) {
						if (!(node instanceof HTMLElement)) {
							return;
						}

						if (node.matches('.js-select2') || node.querySelector('.js-select2')) {
							initSelect2Fields(node);
						}
					});
				}

				if (mutation.type === 'attributes' && mutation.target instanceof HTMLElement) {
					if (!mutation.target.classList.contains('hidden') && (mutation.target.matches('.js-select2') || mutation.target.querySelector('.js-select2'))) {
						initSelect2Fields(mutation.target);
					}
				}
			});
		});

		observer.observe(document.body, {
			subtree: true,
			childList: true,
			attributes: true,
			attributeFilter: ['class']
		});
	}

	window.initSelect2Fields = initSelect2Fields;

	document.addEventListener('DOMContentLoaded', function() {
		initSelect2Fields(document);
		observeSelect2Fields();

		document.addEventListener('focusin', function(event) {
			if (event.target instanceof HTMLElement && event.target.matches('.js-select2')) {
				initSelect2Fields(event.target);
			}
		});
	});

})();